// extracted by mini-css-extract-plugin
export default {"actions":"addUserToCompany_actions__BHA8E","action":"addUserToCompany_action__PIlQn"};